module.exports = __webpack_public_path__ + "img/img9.6dd86bfd.png";